import React, { FC } from 'react';
import { Card, Column, Modal, Row, Spacer, } from '@components/1-atoms';

import { View } from 'react-native';
import Text from '@components/1-atoms/Text';
import ListItem from '@components/2-molecules/ListItem';

import useTheme from '@lib/theme';

import MenuIcon from '@assets/icons/plus'
import { NavigationProp } from '@react-navigation/native';
import { PageProps } from '@lib/constants';

import Illustration from "@assets/estimate-illustration";

const theme = useTheme();
const icon = /* null; // */ <MenuIcon />;


type Props = Omit<PageProps, 'data' | 'currency'> & {};

const WidgetCreateEstimate: FC<Props> = ({ navigation, ...props }) => {

    return (
            <Card
                themed={false}
                // icon={icon}
                // onAction={ openModal}
                title='Create an estimate'
            >

                <View>
                    <Spacer h={3} />

                    {/* Illustration */}
                    <Row style={{ justifyContent: 'flex-start' }}>
                        <Illustration />
                    </Row>
                    <Spacer h={.9} />

                    {/* Description */}
                    <Row>
                        <Column>
                            <Text>Send a quote to a customer for the estimated costs of certain products and services that won't be missed.</Text>
                        </Column>
                    </Row>
                    <Spacer h={3} />

                </View>

                {/* Create an estimate */}
                <View>
                    <ListItem inset onPress={() => navigation?.navigate('EstimateCreate')}>
                    <Text color={theme.pallete.accentColor}>Create an estimate</Text>
                    </ListItem>
                </View>

            </Card>
    );
};

export default WidgetCreateEstimate;